import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Col,
  Row,
  Spin,
  Form,
  Button,
  Modal,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { patchObservaciones } from 'api/recaudacion/recibos';
import getFormattedValues from 'utils/formatValues';
import { onError } from 'utils/handlers';

const ModalAgregarObservacion = ({
  visible,
  setVisible,
  selectedRowKeys,
  callback,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onCancel = () => setVisible(false);

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = getFormattedValues(form.getFieldsValue());
      const [key] = selectedRowKeys;
      const edited = await patchObservaciones(key, values.observaciones);
      if (edited) {
        setVisible(false);
        form.resetFields();
        callback(edited);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const rules = { observaciones: [{ required: true }] };

  return (
    <Modal
      open={visible}
      closable={false}
      footer={null}
      maskClosable={!loading}
      keyboard={!loading}
      title={(

        <FormSubmitControls
          label="Añadir Observaciones"
          onFinish={onFinish}
          onCancel={onCancel}
        />
      )}
      onCancel={onCancel}
      forceRender
      centered
    >
      <Spin
        tip="Cargando..."
        spinning={loading}
      >
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          onFinish={() => onFinish()}
        >
          <Row gutter={10}>
            <Col span={24}>
              <Form.Item
                name="observaciones"
                rules={rules.observaciones}
                label="Observaciones"
              >
                <Input.TextArea allowClear autoSize={{ minRows: 3, maxRows: 5 }} />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalAgregarObservacion.propTypes = {
  setVisible: PropTypes.func.isRequired,
  callback: PropTypes.func,
  visible: PropTypes.bool,
  selectedRowKeys: PropTypes.arrayOf(PropTypes.number),
};
ModalAgregarObservacion.defaultProps = {
  callback: () => {},
  selectedRowKeys: [],
  visible: false,
};

export default ModalAgregarObservacion;
